module.exports = new __parcel__URL__("TeamPickerNoResultsView.fca93e91.svg").toString();